import React from "react";
import { FormattedMessage } from "react-intl";

import { BaseError } from "@apps/viewer/src/ts/components/errors/BaseError";

/**
 * Error message that'll be displayed if an unhandled exception is thrown while
 * rendering the application
 */
// tslint:disable-next-line variable-name
export const ClientError = () => {
    const errorMessage = (
        <FormattedMessage
            id="ErrorMessages__ClientError"
            defaultMessage="Der opstod en fejl. Prøv igen om lidt."
        />
    );

    return <BaseError errorMessage={errorMessage} />;
};
